export const API_URL = "https://calendarevents-backend.vercel.app";
